<div [formGroup]="parentFormGroup" [ngClass]="componentClass" [class.no-label]="!label" [class.error]="isError" [class.disabled]="isDisabled" class="f-form_input">
    <select
            [formControlName]="controlName"
            [id]="controlName"
            [name]="controlName"
            [required]="isRequired"
            [upper-case]="upperCase"
            (change)="onSelect($event)">
      <option
              *ngFor="let option of options; let i = index"
              [value]="option.value"
              [title]="option.value"
              class="atram-option"
              [attr.disabled]="option.disabled ? '' : null"
              [selected]="option.value"
              (click)="onClick($event)">
              {{ option.text }}
      </option>
    </select>
    <label class="label" [for]="controlName" [innerHTML]="label" *ngIf="label"></label>
    <button #button type="button" class="f-button--link btn-ico" (click)="onClick($event)">
        <span class="atram-ico ico-arrow-down"></span>
     </button>
  </div>
  